import { render, staticRenderFns } from "./BackNavigation.vue?vue&type=template&id=0ca0b6dc&scoped=true"
import script from "./BackNavigation.vue?vue&type=script&lang=ts"
export * from "./BackNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BackNavigation.vue?vue&type=style&index=0&id=0ca0b6dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0b6dc",
  null
  
)

export default component.exports